"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
const _excluded = ["onChange", "maxLength", "inputProps", "error", "helperText", "InputProps", "size"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * テキストフィールド部品
 * @prop {string} value - 値
 * @prop {(value: string) => void} onChange - 値確定時（onBlur）に呼ばれるコールバック。イベントオブジェクトは渡されません。
 * @prop {number} [maxLength] - 最大文字数。inputProps.maxLength に自動付与し、超過時は onBlur で切り詰めてから onChange を呼び出します。
 * @prop {Object} [inputProps] - input 要素へ渡す追加属性。maxLength は自動付与されます。
 * @prop {boolean} [error] - エラー表示フラグ。
 * @prop {ReactNode} [helperText] - ヘルパーテキスト（エラーメッセージ等）。
 * @prop {boolean} [multiline] - 複数行入力の可否。false の場合、Enter キー送信を抑止します。
 * @prop {*}  - その他の任意プロパティは @mui/material/TextField の props を参照してください。
 */
class CTextField extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value ? props.value : '',
      isModify: false
    };
  }
  componentDidUpdate(prevProps) {
    const {
      value
    } = this.props;
    // 外的要因での変更時に対応
    const v = value ? value : '';
    if (prevProps.value !== v) {
      this.setState({
        value: v
      });
    }
  }
  render() {
    const _this$props = this.props,
      {
        onChange,
        maxLength,
        inputProps,
        error,
        helperText,
        InputProps,
        size
      } = _this$props,
      rest = _objectWithoutProperties(_this$props, _excluded);
    const {
      value,
      isModify
    } = this.state;
    const hasLabel = !!rest.label;
    const commonProps = _objectSpread(_objectSpread({
      fullWidth: true,
      onBlur: () => {
        if (maxLength && maxLength < value.length) {
          const newValue = value.substring(0, maxLength);
          onChange(newValue);
          this.setState({
            value: newValue
          });
        } else if (isModify) {
          onChange(value);
        }
        this.setState({
          isModify: false
        });
      },
      variant: 'outlined',
      hiddenLabel: !hasLabel,
      size: size || 'small'
    }, rest), {}, {
      onChange: e => {
        this.setState({
          value: e.target.value,
          isModify: true
        });
      },
      inputProps: _objectSpread(_objectSpread({}, inputProps), {}, {
        maxLength
      }),
      InputProps,
      // Input（InputBase）へ追加属性を透過
      value: this.state.value,
      onKeyPress: e => {
        // 単一行（multiline=false）の場合、Enterキーでのフォーム送信を抑止
        if (!this.props.multiline && e.key === 'Enter') {
          e.preventDefault();
        }
      },
      error: !!error,
      helperText: helperText
    });
    return /*#__PURE__*/_react.default.createElement(_TextField.default, commonProps);
  }
}
CTextField.propTypes = {
  value: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  maxLength: _propTypes.default.number,
  multiline: _propTypes.default.bool,
  error: _propTypes.default.bool,
  helperText: _propTypes.default.node,
  InputProps: _propTypes.default.object,
  size: _propTypes.default.oneOf(['small', 'medium'])
};
var _default = exports.default = CTextField;